import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchUserLanguageByEmail } from "../Redux/Api/fetch.api";
import us from "../assets/images/LanguageConversion/us.svg";
import de from "../assets/images/LanguageConversion/de.svg";
import it from "../assets/images/LanguageConversion/it.svg";
import es from "../assets/images/LanguageConversion/es.svg";
import ar from "../assets/images/LanguageConversion/ar.svg";

const languageMap = {
    1: { label: "English", flag: us, code: "en" },
    //  2: { label: "German", flag: de, code: "de" },
    // 3: { label: "Italian", flag: it, code: "it" },
    4: { label: "Spanish", flag: es, code: "es" },
    // 5: { label: "Arabic", flag: ar, code: "ar" },
};

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [languageType, setLanguageType] = useState(1);

    useEffect(() => {
        const email = localStorage.getItem("emailid");
        if (email) {
            fetchUserLanguageByEmail(email)
                .then((response) => {
                    if (response.data.success) {

                        const langId = response.data.data;
                        setLanguageType(langId);

                        // Update i18next language
                        const langCode = languageMap[langId] && languageMap[langId].code || "en";
                        i18n.changeLanguage(langCode);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching user language:", err);
                });
        }
    }, [i18n]);

    const { label: languageSelected, flag } =
        languageMap[languageType] || languageMap[1]; // Default to English

    return (
        <div className="text-center language-span">
            <img src={flag} width={16} alt="flag icon" />
            {languageSelected}
        </div>
    );
};

export default LanguageSwitcher;

